export default {
    Auth: {
        region: 'eu-west-1',
        userPoolId: 'eu-west-1_aV9h4gueW',
        userPoolWebClientId: '2l7bhkg5ri8f95l57t099o1u6m',
        identityPoolId: 'eu-west-1:5542e9b2-1b4a-46d8-a5e0-2e6806f4aa64',
        jwtTokenType: 'JWT'
    }
};
